module.exports = __webpack_public_path__ + "media/components/country-flag/static/bq-bb8094d4c03aee6b8a832116ed02dd33.svg";